import React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';

import { FormElement } from './FormElement';

import type { ChangeEvent } from 'react';

export const InputTextBoxWithLabel = ({
    bottomText,
    disabled = false,
    endAdornment,
    error,
    fullWidth = true,
    helperText,
    label,
    name,
    onBlur,
    onChange,
    placeholder,
    startAdornment,
    type = 'text',
    value,
}: {
    bottomText?: string | React.ReactElement;
    disabled?: boolean;
    endAdornment?: string | React.ReactElement;
    error: boolean;
    fullWidth?: boolean;
    helperText?: React.ReactNode | undefined;
    label: string;
    name: string;
    onBlur?: (e: ChangeEvent) => void;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    startAdornment?: string | React.ReactElement;
    type?: 'text' | 'password' | 'date';
    value: string;
}) => {
    return (
        <FormElement bottomText={bottomText} fullWidth={fullWidth} label={label}>
            <TextField
                disabled={disabled}
                error={error}
                fullWidth={fullWidth}
                helperText={helperText}
                InputProps={{
                    endAdornment: endAdornment ? <InputAdornment position="end">{endAdornment}</InputAdornment> : undefined,
                    startAdornment: startAdornment ? <InputAdornment position="start">{startAdornment}</InputAdornment> : undefined,
                }}
                name={name}
                onBlur={onBlur}
                onChange={onChange}
                placeholder={placeholder}
                size="small"
                type={type}
                value={value}
                variant="outlined"
            />
        </FormElement>
    );
};
